<gipi-abstract-form id="dialogRegisterCreditClient"
                    name="dialogRegisterCreditClient"
                    [dialog]="true">
    <gipi-toolbar mat-dialog-title
                  id="toolbarDialogRegisterCreditClient">
        {{ creditTypeValue === 'CREDIT' ? 'Lançamento de crédito' : 'Lançamento de débito' }}
    </gipi-toolbar>
    <div mat-dialog-content
         fxLayout="column"
         fxLayoutGap="16px">
        <div fxLayout="row"
             fxLayout.lt-sm="column"
             fxLayoutGap="16px">
            <itss-input label="Origem"
                        id="creditClientOriginLaunch"
                        name="creditClientOriginLaunch"
                        [disabled]="true"
                        [(ngModel)]="originLaunchValue"
                        fxFlex
                        fxFlex.lt-sm="100">
            </itss-input>
            <gipi-input-select-enum label="Tipo"
                                    id="creditClientType"
                                    name="creditClientType"
                                    [disabled]="true"
                                    [valuesExclud]="[]"
                                    [enum]="creditTypeEnum"
                                    [(ngModel)]="creditTypeValue"
                                    fxFlex="25"
                                    fxFlex.lt-sm="100">
            </gipi-input-select-enum>
            <gipi-datepicker label="Data da emissão"
                             [disabled]="true"
                             [(ngModel)]="issuanceDate"
                             fxFlex="25"
                             fxFlex.lt-sm="100">
            </gipi-datepicker>
        </div>
        <div fxLayout="row"
             fxLayout.lt-sm="column"
             fxLayoutGap="16px">
            <gipi-input-select-paged label="Cliente"
                                     id="creditClientClient"
                                     name="creditClientClient"
                                     [required]="true"
                                     [disabled]="loading"
                                     [(model)]="client"
                                     [nextBatchFn]="clientFindByValueFn"
                                     [propertyFn]="clientFn"
                                     (selectionChange)="selectionChangeClient($event)"
                                     fxFlex>
            </gipi-input-select-paged>
        </div>
        <div fxLayout="row"
             fxLayout.lt-sm="column"
             fxLayoutGap="16px">
            <gipi-input-select-paged label="Categoria"
                                     id="creditClientPostingCategory"
                                     name="creditClientPostingCategory"
                                     [required]="true"
                                     [disabled]="loading"
                                     [(model)]="postingCategory"
                                     [nextBatchFn]="postingCategoryFindByValueFn"
                                     [propertyFn]="postingCategoryFn"
                                     fxFlex>
            </gipi-input-select-paged>
        </div>
        <div fxLayout="row"
             fxLayout.lt-sm="column"
             fxLayoutGap="16px">
            <gipi-input-select-paged label="Tipo de cobrança"
                                     id="creditClientChargeType"
                                     name="creditClientChargeType"
                                     [required]="true"
                                     [disabled]="loading"
                                     [(model)]="chargeType"
                                     [nextBatchFn]="chargeTypeFindByValueFn"
                                     [property]="'description'"
                                     (selectionChange)="validateBankAccountByCashierShift($event)"
                                     fxFlex>
            </gipi-input-select-paged>
            <itss-input-currency label="Valor"
                                 id="creditClientAmount"
                                 name="creditClientAmount"
                                 placeholder="R$ 0,00"
                                 [required]="true"
                                 [disabled]="loading"
                                 [(ngModel)]="entity.amount"
                                 [options]="{min: 0}"
                                 fxFlex="25"
                                 fxFlex.lt-md="100">
            </itss-input-currency>
            <itss-input-currency label="Saldo atual"
                                 id="creditClientCurrentAmount"
                                 name="creditClientCurrentAmount"
                                 placeholder="R$ 0,00"
                                 [disabled]="true"
                                 [(ngModel)]="currentAmount"
                                 [options]="{min: 0}"
                                 fxFlex="25"
                                 fxFlex.lt-md="100">
            </itss-input-currency>
        </div>
        <div fxLayout="row"
             fxLayout.lt-sm="column"
             fxLayoutGap="16px">
            <itss-select-entity label="Conta bancária"
                                id="creditClientBankAccount"
                                name="creditClientBankAccount"
                                [required]="true"
                                [disabled]="loading"
                                [property]="'description'"
                                [entities]="bankAccountList"
                                [(model)]="bankAccount"
                                fxFlex
                                fxFlex.lt-md="100">
            </itss-select-entity>
        </div>
        <div fxLayout="row"
             fxLayout.lt-sm="column"
             fxLayoutGap="16px">
            <itss-textarea label="Observação"
                           [required]="true"
                           [disabled]="loading"
                           [(ngModel)]="entity.description"
                           [rows]="3"
                           fxFlex
                           fxFlex.lt-md="100">
            </itss-textarea>
        </div>
    </div>
    <div mat-dialog-actions>
        <div fxLayout="row"
             fxLayoutAlign="space-between center"
             fxLayoutGap="16px"
             fxFlexFill>
            <itss-checkbox label="Imprimir recibo após o lançamento"
                           color="primary"
                           [disabled]="loading"
                           [(ngModel)]="printReceiptAfterPosting">
            </itss-checkbox>
            <div fxLayout="row"
                 fxLayoutAlign="end center"
                 fxLayoutGap="16px"
                 fxFlex="50">
                <gipi-button label="Salvar"
                             gipi-primary
                             id="btnSave"
                             name="btnSave"
                             (click)="confirm()"
                             [disabled]="loading"
                             [loading]="loading"
                             fxFlex
                             fxFlex.lt-md="100">
                </gipi-button>
                <gipi-button label="Voltar"
                             gipi-secondary
                             id="btnReturn"
                             name="btnReturn"
                             (click)="close('NONE')"
                             fxFlex
                             fxFlex.lt-md="100">
                </gipi-button>
            </div>
        </div>
    </div>
</gipi-abstract-form>